{
	"back": "Torna alla graduatoria",
	"card": {
		"answer": "Risposta data",
		"candidate": "Candidato",
		"candidate_none": "La domanda non compare nella versione in vigore.",
		"candidate_outcome": "Esito: {{outcome}}",
		"candidate_position": "Posizione {{position}} nella lista {{list}}, punteggio {{score}}, versione {{number}}",
		"closed_by": "Chiusa da {{name}} il {{when}}",
		"closed_by_unknown": "Chiusa il {{when}}",
		"fact": "Fatto registrato: {{fact}}",
		"file": "Documento allegato",
		"file_failed": "Non siamo riusciti ad aprire il documento. Riprova.",
		"open_application": "Apri la domanda",
		"text": "Che cosa dice lo studente",
		"text_erased": "Il testo non c'è più: lo studente ha chiesto la cancellazione dei suoi dati.",
		"title": "Segnalazione",
		"version": "Lo studente leggeva la versione {{number}} della graduatoria."
	},
	"close": {
		"choice": "Come la chiudi?",
		"correct_transcription": "Correggi la trascrizione",
		"corrected": "Registra correzione",
		"corrected_hint": "Il fatto che cambia qualcosa è già registrato: lo scegli qui sotto.",
		"done": "Segnalazione chiusa.",
		"errors": {
			"already_closed": "Un collega l'ha già chiusa: leggi la sua risposta.",
			"default": "Non siamo riusciti a chiudere la segnalazione. Riprova.",
			"fact_invalid": "Quel fatto non è di questa domanda, è precedente alla segnalazione o non ha cambiato la sua riga nella graduatoria. Scegline un altro o chiudi senza correzione."
		},
		"fact_choice": "Fatti registrati su questa domanda dopo la segnalazione",
		"fact_intro": "Prima va registrato il fatto che ha prodotto la correzione. Poi lo scegli qui.",
		"fact_none": "Nessun fatto registrato dopo la segnalazione ha cambiato la riga di questa domanda nella graduatoria: non puoi chiuderla come corretta.",
		"fact_required": "Scegli il fatto che ha prodotto la correzione.",
		"intro": "La segnalazione non è un ricorso e qui non si cambia nessuna posizione: se qualcosa va corretto, si registra prima il fatto con gli strumenti che già ci sono.",
		"no_change": "Nessuna correzione dovuta",
		"no_change_hint": "Il dato è giusto o la graduatoria è corretta così.",
		"open_flags": "Apri le segnalazioni sui requisiti",
		"response": "Risposta allo studente",
		"response_hint": "La legge nella sua area. Almeno {{min}} caratteri.",
		"response_required": "Scrivi almeno {{min}} caratteri.",
		"send": "Chiudi la segnalazione",
		"title": "Chiudi la segnalazione"
	},
	"empty_closed": "Nessuna segnalazione chiusa.",
	"empty_open": "Nessuna segnalazione aperta.",
	"fact_line": "{{type}} · {{subject}} · {{when}}",
	"fact_type": {
		"application_submission_correction": "Correzione di trascrizione",
		"requirement_flag": "Segnalazione sui requisiti chiusa"
	},
	"filters": {
		"closed": "Chiuse",
		"open": "Aperte"
	},
	"list": {
		"doctoral": "Dottorandi e specializzandi",
		"freshers": "Matricole",
		"later_years": "Anni successivi"
	},
	"outcome": {
		"assigned": "posto assegnato",
		"excluded": "esclusa: vale un'altra domanda",
		"forfeited": "decaduta: rinuncia, offerta scaduta, esclusione alla verifica o contratto non firmato",
		"no_seat": "nessun posto",
		"not_admitted": "non ammesso",
		"withdrawn": "ritirata: ha accettato un posto in un'altra struttura"
	},
	"page_title": "Errori segnalati dagli studenti",
	"row": {
		"protocol": "Protocollo {{protocol}}",
		"sent": "Inviata il {{when}}",
		"version": "Versione {{number}}",
		"with_file": "Con allegato"
	},
	"state": {
		"closed_corrected": "Chiusa, correzione registrata",
		"closed_no_change": "Chiusa, nessuna correzione",
		"open": "Aperta"
	},
	"type": {
		"my_data_wrong": "Un mio dato è sbagliato",
		"my_position_wrong": "La mia posizione non mi sembra corretta",
		"other": "Altro"
	}
}
